'use client'

import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { TTermsForm, useSignUpHostStore } from '@/features/sign-up'
import { SignUpTerms } from '@/widgets/sign-up'

export const SignUpHostTerms = () => {
  const router = useRouter()
  const { actions, terms } = useSignUpHostStore()

  const handleFormFieldChange = useCallback(
    (formValues: TTermsForm) => {
      actions.updateTerms(formValues)
    },
    [actions],
  )

  const handleSubmit = () => {
    router.push('/sign-up/host?step=info')
  }

  return (
    <SignUpTerms
      onSubmit={handleSubmit}
      defaultValues={terms}
      onFormFieldChange={handleFormFieldChange}
    />
  )
}
